// extracted by mini-css-extract-plugin
module.exports = {"landscapeContainer":"WOihTcqFhZl99pX7RgFHY","text":"o4vyy_j2RaMEZCIaB_BNi","svg":"BCopsVWZLiEVgQ0n7JO93","rotation":"V2kfoN5VNIw6hXgBp7tQX"};